import type { Workspace } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { eq, useLiveQuery } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { WORKSPACE_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

/**
 * Live workspace query scoped to a specific workspace slug.
 */
export function useWorkspaceBySlug(workspaceSlug: string | undefined): UseLiveQueryReturn<Workspace> | undefined {
  const logger = useRhythmicLogger('useWorkspaceBySlug')
  logger.debug('useWorkspaceBySlug called with slug:', workspaceSlug)
  if (!workspaceSlug) return undefined

  const workspaces = useCollection<Workspace>(WORKSPACE_TABLE, {
    slug: workspaceSlug,
  }).collection
  return useLiveQuery(
    (builder) => {
      return builder
        .from({ w: workspaces })
        .where(({ w }) => eq(w.slug, workspaceSlug))
        .orderBy(({ w }) => w.name, 'asc')
        .limit(1)
    },
    [workspaceSlug],
  )
}
